export default (Alpine) => {

Alpine.directive('clone', (el, { expression }, { evaluate }) => {

		Alpine.nextTick(() => {

			// Try $refs first, then fall back to a selector
			const $refs = evaluate('$refs');
			const source = $refs[expression] || $(expression)[0];
			
			if (!source) {
				
				return;

			}

			// Extract HTML based on element type
			const html = (source.tagName === 'TEMPLATE') ? source.innerHTML : source.outerHTML;

			// Inject and wake up Alpine
			$(el).html(html);
			Alpine.initTree(el);

		});

	});

};